import React from "react";

import { useTranslation } from "utils";

import { CROP_TYPE_FCPO } from "models";

import { Card, Checkbox, CompletenessDataBadge, Flex, Icon, MonthlyEmptyCropCardProps } from "components";

type YearlyEmptyCropCardProps = MonthlyEmptyCropCardProps & {
  isMandatory: boolean;
  isEmptyWithNoEnrollment?: boolean;
  // Multi-selection props
  isChecked?: boolean;
  isCheckboxDisabled?: boolean;
  isInactive?: boolean;
  fieldId: string;
  isFlaggedByVerifier?: boolean;
  openTasksCount?: number;
};

// empty card for HF (yearly empty card view)
export const YearlyEmptyCropCard = ({
  fieldId,
  isSelected,
  isNarrow,
  dataTestId,
  cropType,
  handleClick,
  handleFocus,
  handleBlur,
  isMandatory,
  isEmptyWithNoEnrollment = false,
  isFetching,
  isChecked = false,
  isInactive = false,
  year,
  isFlaggedByVerifier = false,
  openTasksCount = 0,
}: YearlyEmptyCropCardProps) => {
  const { t } = useTranslation("fieldTimeline");

  const addMainOrSideCropText = isEmptyWithNoEnrollment
    ? t(`cropCard.add${cropType ? cropType.charAt(0).toUpperCase() + cropType.slice(1).toLowerCase() : ""}`) // convert all Caps to Capitalized str!
    : t(`cropCard.add${cropType === CROP_TYPE_FCPO.MAIN ? "Main" : "Side"}Crop`);

  return (
    <Card
      className={`empty-yearly-crop-card layout  ${isSelected ? "selected" : ""} ${isNarrow ? "is-narrow" : ""} ${isMandatory ? "mandatory" : "optional"} ${
        isInactive ? "inactive-card" : ""
      }`}
      onClick={isFetching || isInactive ? () => {} : handleClick}
      onFocus={isInactive ? undefined : handleFocus}
      onBlur={isInactive ? undefined : handleBlur}
      data-testid={`empty-crop-card-${dataTestId}`}
      data-year={year}
      data-fieldid={fieldId}
      tabIndex={0}
    >
      <Flex align="center" justify="flex-start" gap="0.5rem">
        {/* Handling onClick in AllFieldsTimelines (handleCardClick()) to also check the box when the crop card (not just the checkbox) is clicked. */}
        {!isInactive && <Checkbox checked={isChecked} data-testid={`empty-crop-checkbox-${dataTestId}`} />}
        <Flex>
          {!isMandatory && (
            <>
              <Icon iconName="klim/plus" className="add-icon inline icon " style={{ marginRight: "0.5rem" }} />{" "}
            </>
          )}
          <div className="add-text-container">
            <span className={`add-text ${isMandatory ? "mandatory" : "optional"}`}>
              {/* {isNarrow || shouldShowNameTooltip ? <span className="add-text-span">{addCropText}</span> : <>{addCropText}</>} */}
              {addMainOrSideCropText}
            </span>
          </div>
        </Flex>
        {isFlaggedByVerifier && <CompletenessDataBadge isComplete={false} isConfirmed={false} openTaskCount={openTasksCount} />}
      </Flex>
    </Card>
  );
};
